import React, { useState, useEffect, useRef } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { useNavigate, useLocation } from "react-router-dom";
import "./css/languageSwitcher.scss";

function LanguageSwitcher({ isOpen, onOpen, onClose }) {
  const { language, toggleLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const switcherRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (switcherRef.current && !switcherRef.current.contains(event.target)) {
        onClose(); // Закрываем, если клик вне переключателя
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  // const handleLanguageChange = (selectedLanguage) => {
  //   if (language !== selectedLanguage) {
  //     toggleLanguage(selectedLanguage);
  
  //     let currentPath = location.pathname;
      
  //     // Удаляем старый /pl (если есть)
  //     currentPath = currentPath.replace(/\/pl$/, "");
  
  //     // Если выбран польский язык, добавляем /pl, но корректно
  //     if (selectedLanguage === "pl") {
  //       currentPath = `/pl${currentPath}`;
  //     }
  
  //     navigate(currentPath, { replace: true });
  //   }
  //   onClose();
  // };

  // const handleLanguageChange = (selectedLanguage) => {
  //   if (language !== selectedLanguage) {
  //     toggleLanguage(selectedLanguage);
  
  //     let currentPath = location.pathname;
  //     currentPath = currentPath.replace(/\/pl$/, ""); // Убираем /pl, если есть
  
  //     if (selectedLanguage === "pl") {
  //       currentPath += "/pl"; // Добавляем /pl для польского языка
  //     }
  
  //     navigate(currentPath, { replace: true });
  //   }
  //   onClose();
  // };

  // const handleLanguageChange = (selectedLanguage) => {
  //   if (language !== selectedLanguage) {
  //     toggleLanguage(selectedLanguage);
  
  //     let currentPath = location.pathname;
  
  //     // Убираем /pl в конце, если оно есть
  //     currentPath = currentPath.replace(/\/pl$/, "");
  
  //     // Если текущий путь == "/", не добавляем просто "/pl", а делаем "/home/pl"
  //     if (currentPath === "/") {
  //       currentPath = "/home";
  //     }
  
  //     // Если выбран польский язык, добавляем /pl в конец
  //     if (selectedLanguage === "pl") {
  //       currentPath += "/pl";
  //     }
  
  //     navigate(currentPath, { replace: true });
  //   }
  //   onClose();
  // };
  
  const handleLanguageChange = (selectedLanguage) => {
    if (language !== selectedLanguage) {
      toggleLanguage(selectedLanguage);
  
      let currentPath = location.pathname;
  
      // Убираем "/pl" в конце, если есть
      currentPath = currentPath.replace(/\/pl$/, "");
  
      // Проверяем, если мы на главной странице ("/"), не пытаемся сделать "/pl/", а просто "/pl"
      if (currentPath === "/") {
        currentPath = "";
      }
  
      // Добавляем "/pl" в конец пути
      if (selectedLanguage === "pl") {
        currentPath += "/pl";
      }
  
      navigate(currentPath || "/", { replace: true }); // Если пусто, ставим "/"
    }
    onClose();
  };
  
  return (
    <div className="language-switcher" ref={switcherRef}>
      <div className="selected-language" onClick={isOpen ? onClose : onOpen}>
        <img
          src={`/img/translate/${language === "en" ? "usa.svg.png" : "poland.svg.webp"}`}
          alt="Selected Language"
        />
      </div>
      {isOpen && (
        <ul className="dropdown">
          <li onClick={() => handleLanguageChange("en")}>
            <img src="/img/translate/usa.svg.png" alt="English" />
            English
          </li>
          <li onClick={() => handleLanguageChange("pl")}>
            <img src="/img/translate/poland.svg.webp" alt="Polish" />
            Polski
          </li>
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;

